export default __webpack_public_path__ + "static/media/green_bluesml.6c7f6873.gif";